import type { ShiftSplit } from '../api/generated/ShiftSplit'
import { addMinutes, minutesBetween } from './time'

/**
 * Boundaries of the consecutive shifts cutting `from`–`to` (local times), at whole minutes like
 * the API's split: `parts` equal shifts, or shifts of `minutes`, the last one shorter. Empty when
 * the range or the split is invalid.
 */
export function sliceBounds(from: string, to: string, split: ShiftSplit): string[] {
  const total = minutesBetween(from, to)
  const size = 'parts' in split ? split.parts : split.minutes
  if (!Number.isInteger(size) || size < 1 || !(total > 0)) return []
  const offsets: number[] = []
  if ('parts' in split) {
    if (size > total) return []
    for (let i = 1; i < size; i++) offsets.push(Math.floor((total * i) / size))
  } else {
    for (let offset = size; offset < total; offset += size) offsets.push(offset)
  }
  return [from, ...offsets.map((offset) => addMinutes(from, offset)), to]
}
